import { useState } from 'react'
import { Row, Col, Badge, Button } from 'react-bootstrap'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import { useMunicipalityIssues } from 'api/hooks/use-municipality-issues'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn, faToggleOff, faBell } from '@fortawesome/free-solid-svg-icons'

import { SeverityBadge } from 'shared/badges'
import NotificationConfigModal from './NotificationConfigModal'

function IssuesIndex() {
  const [showNotificationModal, setShowNotificationModal] = useState(false)
  const crumbs = [
    { name: 'Access Management', url: 'duties' },
    { name: 'Issues', url: '' }
  ]
  const { data: issues, isSuccess } = useMunicipalityIssues({})

  const navigateToIssue = (id) => {
    window.location.href = `/issues/${id}`
  }

  return (
    <Page title={'Access Management'}>
      <PageTitle breadcrumbs={crumbs} />
      <div className="d-flex align-items-center gap-3 mb-4">
        <h2 className="mb-0">Issues</h2>
        <Button
          variant="outline-light"
          size="sm"
          style={{ backgroundColor: 'white', color: '#333', borderColor: '#dee2e6' }}
          onClick={() => setShowNotificationModal(true)}
        >
          <FontAwesomeIcon icon={faBell} className="me-2" />
          Configure notifications
        </Button>
      </div>

      <NotificationConfigModal
        show={showNotificationModal}
        onHide={() => setShowNotificationModal(false)}
      />

      <Row>
        <Col sm={10} className="mb-3">
          {isSuccess &&
            issues.map((issue, index) => (
              <Card
                key={index}
                action
                className="mb-3 shadow-sm"
                style={{ cursor: 'pointer' }}
                onClick={() => navigateToIssue(issue.id)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = '#f9f9f9')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = '')
                }
              >
                <Card.Body className="d-flex flex-column">
                  <div>
                    <Row>
                      <Col sm="auto">
                        <div>
                          <strong>{issue?.issue?.name}</strong>
                          {issue?.subscribed && (
                            <Badge className="bg-white border text-primary ms-2" title="Subscribed to notifications">
                              <FontAwesomeIcon icon={faBell} size="xs" className="text-primary me-1" />
                              Subscribed
                            </Badge>
                          )}
                        </div>
                        <div className="text-muted small">
                          {issue?.issue?.description}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col
                        md="auto"
                        className="d-flex flex-column align-items-center me-4"
                      >
                        <div className="justify-content-center">
                          <div className="text-muted">Severity</div>
                          <div className="text-dark text-center">
                            <SeverityBadge
                              severity={issue.severity}
                              count={issue.count}
                              displayCount={true}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col
                        md="auto"
                        className="d-flex flex-column align-items-center me-4"
                      >
                        <div>
                          <div className="text-muted">
                            <span style={{ backgroundColor: '#E9C46A', borderRadius: '50%', display: 'inline-block', width: '8px', height: '8px', marginRight: '5px' }}></span>
                            Unresolved
                          </div>
                          <div className="text-dark text-center">
                            {`${issue.unresolved_count}`}
                          </div>
                        </div>
                      </Col>
                      <Col
                        md="auto"
                        className="d-flex flex-column align-items-center me-4"
                      >
                        <div>
                          <div className="text-muted">
                            <span style={{ backgroundColor: '#27AB83', borderRadius: '50%', display: 'inline-block', width: '8px', height: '8px', marginRight: '5px' }}></span>
                            Resolved
                          </div>
                          <div className="text-dark text-center">
                            {`${issue.resolved_count}`}
                          </div>
                        </div>
                      </Col>
                      <Col
                        md="auto"
                        className="d-flex flex-column align-items-center"
                      >
                        <div>
                          <div className="text-muted">
                            <span style={{ backgroundColor: '#606060', borderRadius: '50%', display: 'inline-block', width: '8px', height: '8px', marginRight: '5px' }}></span>
                            Ignored
                          </div>
                          <div className="text-dark text-center">
                            {`${issue.ignored_count}`}
                          </div>
                        </div>
                      </Col>
                      {false && (
                        <Col
                          md={1}
                          className="d-flex flex-column align-items-center"
                        >
                          <div className="text-muted">Enabled</div>
                          <div className="form-check form-switch ps-0">
                            {issue.is_issue_enabled ? (
                              <FontAwesomeIcon icon={faToggleOn} />
                            ) : (
                              <FontAwesomeIcon icon={faToggleOff} />
                            )}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            ))}
        </Col>
      </Row>
    </Page>
  )
}

export default IssuesIndex
